var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Row } from "./";
import Text from "./Text";
import React from 'react';
import { styled } from "../utils";
var StyledLabel = styled(Text)({
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
});
var ProductPriceRow = function (_a) {
    var value = _a.value, label = _a.label, caption = _a.caption, _b = _a.large, large = _b === void 0 ? false : _b, className = _a.className, priceRef = _a.priceRef, spaceProps = __rest(_a, ["value", "label", "caption", "large", "className", "priceRef"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, __assign({}, spaceProps, { className: className, justifyContent: "flex-end", flexDirection: "column", alignItems: "flex-start" }),
            React.createElement(StyledLabel, { fontFamily: "primary", fontWeight: large ? 'bold' : 'medium', fontSize: "normal", mt: "extraTiny" }, label),
            React.createElement(Text, { fontFamily: "primary", fontSize: "normal", fontWeight: "bold", whiteSpace: "nowrap" }, value))));
};
export default ProductPriceRow;
//# sourceMappingURL=ProductPriceRow.js.map